var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

var ActionTypes = AppActionConstants.ActionTypes.users;
var GenresActionTypes = AppActionConstants.ActionTypes.genres;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];
var _resourceData = {};
var _allGenres = [];
var _instructors = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var CodeStore = assign({}, ModelStore, {
	getResourceListData: function () {
		for(var i=0; i < _resourceListData.length; i++)
		{
			_resourceListData[i]['used'] = _resourceListData[i]['used'] == 1? 'Yes':'No';
		}
		return _resourceListData;
	},

	getResource: function () {
		for(var i=0; i < _resourceData.length; i++)
		{
			_resourceData[i]['used'] = _resourceData[i]['used'] == 1? 'Yes':'No';
		}
		return _resourceData;
	},

	getAllGenres: function () {
		return _allGenres;
	},

	getResourceById: function (id) {
		// http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
		var index = _resourceListData.map(function(item) {
			return item.id;
		}).indexOf(Number(id));

		return _resourceListData[index];
	},

	getInstructors: function () {
		return _instructors;
	}
});

/**
 * Event Listeners
 */
CodeStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'ACTIVATION-CODES_RECEIVED':
			_resourceData = action.data;

			CodeStore.emitChange();
			break;
		case 'ACTIVATION-CODES_CREATED':
			_resourceData = action.data;

			CodeStore.emitChange();
			break;
		case 'ACTIVATION-CODES_LISTED':
			_resourceData = action.data;

			CodeStore.emitChange();
			break;
		case 'ME_LISTED':
			_resourceData = action.data;

			CodeStore.emitChange();
			break;
	}
});

module.exports = CodeStore;
